module.exports = __webpack_public_path__ + "img/bba285b.jpg";